import React from 'react';
import {ChatSessionsList} from "../../pages/admin/index";

/**
 * ClientSessionsList Component
 * 
 * Renders a list of chat sessions for an advisor user.
 * This component wraps the ChatSessionsList component with retirement advisor role configuration.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.loginUser - The logged-in user information including authentication details
 * @returns {JSX.Element} A component displaying the advisor's client chat sessions
 */
export default function ClientSessionsList(props) {

    const {loginUser} = props;

    return (
        <ChatSessionsList 
            retirementRole = "advisor"
            loginUser = {loginUser}
        />
    );
}
